import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const Laundry: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <g clipPath="url(#clip0_507_494)">
                <IconPath
                    d="M8.25 10.5H0.75M8.25 10.5L18.75 21M8.25 10.5L8.25 6.5H21.25C21.5126 6.5 21.7727 6.55173 22.0154 6.65224C22.258 6.75275 22.4785 6.90007 22.6642 7.08579C22.8499 7.2715 22.9972 7.49198 23.0978 7.73463C23.1983 7.97728 23.25 8.23736 23.25 8.5C23.25 8.76264 23.1983 9.02272 23.0978 9.26537C22.9972 9.50802 22.8499 9.7285 22.6642 9.91421C22.4785 10.0999 22.258 10.2472 22.0154 10.3478C21.7727 10.4483 21.5126 10.5 21.25 10.5L8.25 10.5ZM0.75 10.5V6C0.781712 5.3322 1.01311 4.68928 1.41424 4.15443C1.81537 3.61958 2.36779 3.21743 3 3C3.63221 3.21743 4.18463 3.61958 4.58576 4.15443C4.98689 4.68928 5.21829 5.3322 5.25 6V10.5L0.75 10.5ZM18.75 10.5L8.25 21"
                    {...pathProps}
                />
            </g>
            <defs>
                <clipPath id="clip0_507_494">
                    <rect width="24" height="24" fill="transparent" />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
